<script>
export default {
    name: "DiagnosisTab",

    props: {
        progressNotes: Array,
        progressNotesDocs: Array,
        encounters: Array,
    },

    methods: {

        printMedicalFile() {
            window.print();
        },
    },
    // components: {
    //     'view-file': () => import('./modals/ViewProgressNotesFiles.vue')
    // },
}
</script>
<template>
    <div class="w-full flex-wrap">
        <div class="w-full p-1 hide--print">
            <span class="py-px px-3 font-medium bg-blue-800 text-white rounded text-xs mr-2">Inpatient</span>
            <span class="py-px px-3 font-medium bg-blue-400 text-white rounded text-xs mr-2">Outpatient</span>
            <span class="py-px px-3 font-medium bg-yellow-500 text-white rounded text-xs mr-2">Triage</span>
            <span class="py-px px-3 font-medium bg-green-500 text-white rounded text-xs mr-2">Discharge</span>
        </div>
        <div class="w-full" 
            v-for="encounter in encounters"
            :key="encounter.encounterId">
            <div class="w-full flex flex-wrap p-1 rounded-t-md"
                :class="{
                    'bg-blue-400': encounter.category == `OutPatient`,
                    'bg-blue-800' : encounter.category == `InPatient`,
                    'bg-yellow-500' : encounter.category == `Triage`,
                }"
                v-if="progressNotes.length && 
                    progressNotes.filter(diag => encounter.encounterId==diag.encounterId).length">
                <div class="flex-1">
                    <h5 class="font-medium text-white text-sm">
                        Encounter #{{ encounter.encounterId }} Visit #{{encounter.visitNo}}</h5>
                </div>
                <div class="flex-1">
                    <router-link
                      v-if="
                            ($root.formatLowercase(encounter.userName) ==
                            $root.formatLowercase($root.username)) ||
                            $root.checkAuth('AdminEditMedicalFile')
                          " 
                      :to="{
                        name: `med-f.visit.index`,
                        params: {
                          patientID: $route.params.patientID,
                          visitNo: $route.params.visitNo,
                        },
                        query: {
                          encounterID: encounter.encounterId,
                          from: $route.query.from,
                        },
                      }" 
                      class="btn-sm btn-warning text-xs text-white rounded hide--print"> 
                        Edit Encounter</router-link>
                </div>
                
            </div>
            
            <div class="w-full p-1 flex flex-wrap bg-gray-200 my-1 text-sm" v-for="diag in 
                progressNotes.filter(diag => encounter.encounterId == diag.encounterId)" 
                :key="diag.diagnosisId">
                <div class="md:w-1/4 w-1/2 p-1">
                    <h5 class="font-medium">
                        <span>Date: </span><span>{{ diag.sysDate | dateFormatDT }}</span></h5>
                </div>
                 <div class="md:w-1/4 w-1/2 p-1">
                    <h5 class="font-medium">
                        <span>Progress: </span><span  v-html="diag.progressNotes" class="break-words"></span></h5> 
                </div>
                
                <div class="md:w-1/4 w-1/2 p-1">
                    <h5 class="font-medium">
                        <span>User Name: </span><span>{{ diag.userName}}</span></h5>  
                      
                </div>
            
            </div>
                <table class="table"  v-if="progressNotesDocs.filter(diag =>diag.encounterID==encounter.encounterId).length">
                    <!-- <table class="table"> -->
                <!-- <thead class="bg-blue-500 text-white text-sm">
                     <tr>
                         <th class="p-tiny">Id</th> 
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Document</th>
                          <th class="p-tiny">Username</th>
                        <th class="p-tiny hide--print">Action</th> 
                    </tr>
                </thead> -->
                <tbody class="text-xs bg-gray-100">
                    <tr v-for="medFile in progressNotesDocs.filter(diag => diag.encounterID==encounter.encounterId)" :key="medFile.id">
                        <!-- <td class="p-tiny">{{ medFile.id }}</td> -->
                        
                        <td class="p-tiny">
                            <h5 class="bg-blue-500 text-white text-sm text-center">Recorded On: {{ medFile.date | dateFormat }}     Doctor: {{ medFile.doctorName?medFile.doctorName:"-"  }}        Recorded By: {{ medFile.userName?medFile.userName:"-"  }}</h5>  <iframe
              v-if="medFile.contentType == `application/pdf`"
              :src="`data:application/pdf;base64,${medFile.document}`"
              height="800"
              width="1150"
            ></iframe>
            <img
              v-else
              :src="`data:application/image;base64,${medFile.document}`"
              :alt="medFile.docName"
            /></td>
                        <!-- <td class="p-tiny hide--print">
                            <button
                                @click.prevent="medFile.view = true"
                                class="btn-sm btn-info rounded m-px">
                                    <i class="fa fa-eye"></i> View</button>
                            <view-file 
                                :showModal="medFile.view"
                                :file="medFile"
                                @closeModal="medFile.view=false"
                            />
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-right">
            <button 
                @click.prevent="printMedicalFile"
                class="btn-sm btn-primary text-xs hide--print">
                    <i class="fa fa-print"></i> Print</button>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
